import services from 'services/services';
import * as types from '../../types';
import { setRequestUrl } from 'store/actions';

// Import helpers
import {
	checkFetchErrors,
	queryParams
} from '../../helpers_actions/convert_helpers';

// Import variables
import { TABLE_LENGTH } from 'components/helpers/table';

// ******************** FETCH SEASONS - TABLE DATA ********************
export const fetchSeasons = (options, id, resources) => async (
	dispatch,
	getState
) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_SEASONS_LOADING,
			payload: true
		});

		const {
			vod: {
				season_table: {
					columns,
					options: {
						filters: { filterUrlQuery }
					}
				}
			}
		} = getState();

		// filer vod list for audio or vod only
		const audioQuery = `is_audio=${resources?.isAudio ? '1' : '0'}&`;

		const url = `/vod/${id}/list?${audioQuery}${filterUrlQuery}${queryParams(
			options,
			TABLE_LENGTH,
			columns
		)}`;

		const { data } = await services.get(url);

		// Calculate pages
		const pages = Math.ceil(data.recordsFiltered / TABLE_LENGTH);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_SEASONS_SUCCESS,
			payload: { ...data, pages }
		});

		// save request url in redux
		setRequestUrl(url)(dispatch);
	} catch (error) {
		dispatch({
			type: types.FETCH_SEASONS_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** DELETE SEASON ********************
export const deleteSeason = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.DELETE_SEASON_LOADING,
			payload: true
		});

		await services.delete(`/vod/season/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.DELETE_SEASON_SUCCESS,
			payload: true
		});
	} catch (error) {
		// Dispatch an action with error set to true
		dispatch({
			type: types.DELETE_SEASON_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** SET SEARCH QUERY ********************
export const setSeasonsQuery = (query) => ({
	type: types.SET_SEASONS_SEARCH_QUERY,
	payload: query
});
